import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";
import { toast } from "react-hot-toast";

export const editQuickAccessApi = createAsyncThunk(
    'quickAccess/edit',
    async (data, { rejectWithValue }) => {
        try {
            const { id, ...payload } = data;
            const response = await AuthAxios.patch(apiRoutes.quickAccessAction(id, 1), payload);
            toast.success(response?.data?.message || "Quick Access Updated Successfully", {
                id: "toast",
                duration: 2000,
                position: "top-center",
            });
            return response?.data;
        } catch (error) {
            let errorMsg = error?.response?.data?.message || "Something went wrong";
            if (typeof errorMsg === 'object') {
                errorMsg = Object.values(errorMsg).flat().join(', ');
            }
            toast.error(errorMsg, {
                id: "toast",
                duration: 2000,
                position: "top-center",
            });
            return rejectWithValue(error?.response?.data);
        }
    }
);

const editQuickAccessSlice = createSlice({
    name: 'editQuickAccess',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetEditQuickAccess: (state) => {
            state.result = [];
            state.loading = false;
            state.error = null;
            state.message = "";
        }
    },
    extraReducers: (builder) => {
        builder.addCase(editQuickAccessApi.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(editQuickAccessApi.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action?.payload?.result;
            state.message = action?.payload?.message;
        });
        builder.addCase(editQuickAccessApi.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.payload?.error;
            state.message = action?.payload?.message;
        });
    },
});

export const { resetEditQuickAccess } = editQuickAccessSlice.actions;
export const editQuickAccessReducer = editQuickAccessSlice.reducer;
